module.exports = __webpack_public_path__ + "img/empresas_pasarela_de_pagos.a090d005.svg";